import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import {
  MbModalComponent, MbSuccessModalComponent,
} from '../index';
import { IAccountContent } from '../../../core/services/accounts.service';
import { EditStaffFormComponent } from '../../forms/organizations/edit-staff-form/edit-staff-form.component';

@Component({
  selector: 'app-mb-edit-staff-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzModalModule,
    NzSelectModule,
    NzFormModule,
    NzButtonModule,
    NzDividerModule,
    MbModalComponent,
    EditStaffFormComponent,
    MbSuccessModalComponent,
  ],
  templateUrl: './mb-edit-staff-modal.component.html',
})
export class MbEditStaffModalComponent{
  @Input() isVisible = false;
  @Input() staffData: IAccountContent | null = null;
  @Input() organizationId = '';
  @Output() isVisibleChange = new EventEmitter<boolean>();

  @ViewChild('editStaffForm', { static: false }) editStaffFormComponent!: EditStaffFormComponent;

  isSuccessModalVisible = false;
  successMessage = '';

  handleEditStaffSubmit(): void {
    if (this.editStaffFormComponent) {
      this.editStaffFormComponent.onSubmit(() => {
        this.showSuccessModal('Staff member updated successfully!');
        this.isVisibleChange.emit(false);
      });
    } else {
      console.error('editStaffFormComponent is not available');
    }
  }

   showSuccessModal(message?: string): void {
    this.successMessage = message || 'completed successfully!';
    this.isSuccessModalVisible = true;
  }

  closeSuccessModal(): void {
    this.isSuccessModalVisible = false;
  }
}
